import { TimePeriod } from "../../discover-sort-constants";

export const Past1H = "Past1H";

export type WidgetTimePeriod = TimePeriod | typeof Past1H;

const STANDARD_WIDGET_TIME_PERIODS = new Set(Object.values(TimePeriod));

const isStandardWidgetTimePeriod = (
  timePeriod: WidgetTimePeriod,
): timePeriod is TimePeriod =>
  STANDARD_WIDGET_TIME_PERIODS.has(timePeriod as TimePeriod);

export enum WidgetPreset {
  topJoiners = "top-joiners",
  topEarners = "top-earners",
  topCoins = "top-coins",
}

export const normalizeWidgetTimePeriod = (
  preset: WidgetPreset,
  timePeriod: WidgetTimePeriod,
): WidgetTimePeriod => {
  if (preset === WidgetPreset.topCoins) {
    if (timePeriod === TimePeriod.AllTime) {
      return TimePeriod.Past24H;
    }

    return timePeriod;
  }

  if (timePeriod === Past1H || !isStandardWidgetTimePeriod(timePeriod)) {
    return TimePeriod.Past24H;
  }

  return timePeriod;
};
